import {Dispatch} from 'react'
import {
  generalShowLoader,
  generalOpenModalError,
  generalOpenModalMessage,
} from '../../general.actions'
import {KEYS} from '../../../constants/keysStorage'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {GESTION_CLIENTES_TYPES} from '../../../constants/gestionCliente.types'
import {ClienteFilaCarga} from '../../../interfaces/gestion-cliente.interface'

export const setDataFileClientes = (dataFile: ClienteFilaCarga[]) => ({
  type: GESTION_CLIENTES_TYPES.AC_SET_FILE_DATA_CARGADA,
  payload: dataFile,
})

export const clearDataFileClientes = () => ({
  type: GESTION_CLIENTES_TYPES.AC_CLEAR_FILE_DATA,
})

export const postCargarClientes =
  (itemsFile: ClienteFilaCarga[], onSuccess?: () => void) => async (dispatch: Dispatch<any>) => {
    if (!itemsFile?.length) return false

    dispatch(generalShowLoader(true))

    const id_user = localStorage.getItem(KEYS.ID_CLIENT)

    const body = {
      itemsFile,
      usuariocreacion: id_user,
      codigoempresa: localStorage.getItem(KEYS.CODIGO_EMPRESA) ?? '',
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
    }

    return await http
      .post(ENDPOINTS.GESTION_CLIENTES_CARGAR_NUEVO, body, {}, KEYS.TOKEN)
      .then(() => {
        dispatch(generalShowLoader(false))
        dispatch(
          generalOpenModalMessage(
            'Carga exitosa',
            `Se cargaron ${itemsFile.length} cliente(s) correctamente.`
          )
        )
        if (onSuccess) onSuccess()
        return true
      })
      .catch((err: any) => {
        const messageErr = 'No se logró cargar los clientes, intente nuevamente.'
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? messageErr,
            err?.response?.data?.status
          )
        )
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
